import React from 'react'
import cx from 'classnames'
import { t, ngettext, msgid } from 'ttag'

import { WarningFilledIcon } from 'components/shared/Icon/model'
import { IconTooltip } from 'components/shared/IconTooltip/IconTooltip'

import styles from './CautionSign.module.scss'

type CautionSignProps = {
  count?: number
  placement?: React.ComponentProps<typeof IconTooltip>['placement']
  size?: number
  className?: string
}

/**
 * Marks a score that falls outside the range preferred for a role's job
 * demands, so that it gets a closer look in the overall assessment.
 *
 * Pass `count` to summarise several scores at once, for instance next to a tab
 * covering more than one of them.
 */
export const CautionSign = ({
  count = 1,
  placement,
  size = 18,
  className,
}: CautionSignProps) => {
  if (!count) {
    return null
  }

  const text =
    count > 1
      ? ngettext(
          msgid`${count} score is outside the preferred range for this role's job demands; explore further in the overall assessment.`,
          `${count} scores are outside the preferred range for this role's job demands; explore further in the overall assessment.`,
          count,
        )
      : t`The candidate's score in this area is outside the preferred range for this role's job demands; consider this in the overall assessment.`

  return (
    <IconTooltip
      icon={WarningFilledIcon}
      className={cx(styles.sign, className)}
      iconClassName={styles.icon}
      {...{ text, placement, size }}
    />
  )
}
